<template>
<v-navigation-drawer v-model="drawerVisible" width="240" clipped app v-if="!drawerDisabled">
  <v-list>
    <template v-for="item in countedMenu">
      <v-list-tile :to="item.path" :key="item.title" v-if="item.title !== 'menu.maintain' || item.count !== 0">
        <v-list-tile-action style="min-width:40px">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-chip disabled small v-if="!!item.count" color="grey lighten-4"> {{ item.count }} </v-chip>
        </v-list-tile-action>
      </v-list-tile>
    </template>
  </v-list>
  <v-divider></v-divider>
  <v-list>
    <v-list-tile to="/">
      <v-list-tile-action style="min-width:40px">
        <v-icon>explore</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t('menu.introduce') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile @click="signIn" v-if="!userLoading && !userMail">
      <v-list-tile-action style="min-width:40px">
        <v-icon>person</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t('menu.login') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile @click="signOut" v-if="!userLoading && userMail">
      <v-list-tile-action style="min-width:40px">
        <v-icon>person_outline</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t('menu.logout') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</v-navigation-drawer>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'Drawer',
  mixins: [UserAuth],
  props: ['drawer', 'menus', 'logo', 'headerBackground'],
  computed: {
    drawerVisible: {
      get: function() {
        return this.drawer
      },
      set: function(newValue) {
        this.$emit('update:drawer', newValue);
      }
    },
    drawerDisabled() {
      return this.$route.meta.disableToolbar;
    },
    countedMenu() {
      let menu = this.menus;
      for (let m of menu) {
        switch (m.path) {
          case '/scene':
            m.count = Object.values(this.userScene).reduce((acc, cur) => {
              return acc + cur.length;
            }, 0);
            break;
          case '/macro':
            m.count = Object.values(this.userMacro).reduce((acc, cur) => {
              return acc + cur.length;
            }, 0);
            break;
          case '/actuator':
            m.count = Object.values(this.userDevice).reduce((acc, cur) => {
              return acc + Object.values(cur).reduce((acc1, cur1) => {
                return acc1 + Object.values(cur1.channel || []).filter(c => c.ctrltype).length;
              }, 0);
            }, 0);
            break;
          case '/sensor':

            m.count = Object.values(this.userDevice).reduce((acc, cur) => {
              return acc + Object.values(cur).reduce((acc1, cur1) => {
                return acc1 + Object.values(cur1.channel || []).filter(c => !c.ctrltype && c.functype < 99 && c.functype > 0).length;
              }, 0);
            }, 0);
            break;
          case '/maintain':
            m.count = Object.values(this.userDevice).reduce((acc, cur) => {
              return acc + Object.values(cur)
                .filter(c => c.battery > 0 && c.battery < 35 || c.battery == 238)
                .reduce((acc1, cur1) => {
                  return acc1 + Object.values(cur1.channel || []).filter(c => c.functype).length;
                }, 0);
            }, 0);
            break;
          case '/camera':
            m.count = Object.values(this.userCamera).reduce((acc, cur) => {
              return acc + Object.values(cur).reduce((acc1, cur1) => {
                return acc1 + Object.values(cur1).length;
              }, 0);
            }, 0);
            break;
          case '/gateway':
            m.count = Object.values(this.userMacInfo).length;
            break;
          case '/contact':
            m.count = Object.values(this.userContact).length;
            break;
          case '/map':
            m.count = Object.values(this.userMacInfo).map(i => i.map).filter(i => i && i.length > 3).length;
            break;
          case '/schedule':
            m.count = Object.values(this.userSchedule).length;
            break;
          case '/labeling':
            m.count = Object.values(this.userFace).length;
            break;
          case '/kanban':
            m.count = Object.values(this.userKanban).length;
            break;
          case '/route':
            m.count = Object.values(this.userMacInfo).length;
            break;
          case '/tracker':
            m.count = Object.values(this.userTracker).length;
            break;
        }
      }
      return menu;
    }
  },
  methods: {
    openUrl(url) {
      window.open(url, '_blank');
    },
    goHome() {
      this.$router.push('/');
    },
    signIn() {
      this.$router.replace('/login');
    },
    signOut() {
      this.$auth.signOut();
      window.location.href = '/';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/Drawer.vue